function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('./module/cart'),
  restoreCalc = _require.restoreCalc;
var getExcludedDepartments = function getExcludedDepartments(basket) {
  if (!(basket !== null && basket !== void 0 && basket.priceTaxFeeAdjusters) || !basket.priceTaxFeeAdjusters.length) {
    return [];
  }
  var ptfs = basket.priceTaxFeeAdjusters;
  var feebusterPTF = ptfs.find(function (ptf) {
    return ptf.name === 'feebuster';
  });
  return feebusterPTF ? feebusterPTF.supplementalData.excludedDepts : [];
};
var getFeebusterConfig = function getFeebusterConfig(purchases) {
  for (var i = 0; i < purchases.length; i++) {
    var purchase = purchases[i];
    if (purchase.priceTaxFeeAdjustments) {
      for (var j = 0; j < purchase.priceTaxFeeAdjustments.length; j++) {
        var ptf = purchase.priceTaxFeeAdjustments[j];
        if (ptf.name === 'feebuster') {
          var _ptf$extra;
          return (_ptf$extra = ptf.extra) === null || _ptf$extra === void 0 ? void 0 : _ptf$extra.config;
        }
      }
    }
  }
  return null;
};
var unpackBasket = function unpackBasket(basket) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$pointsConfig = _ref.pointsConfig,
    pointsConfig = _ref$pointsConfig === void 0 ? {} : _ref$pointsConfig;
  var excludedDepts = getExcludedDepartments(basket);
  var feebusterConfig = getFeebusterConfig(basket.purchases);
  var gpi = {
    fee_buster_config: {
      enabled: false,
      fraction: null,
      manualinclusive: false
    },
    price_increase: {
      enabled: false,
      excludedDepts: []
    }
  };
  var gpiConfig = feebusterConfig ? {
    fee_buster_config: {
      enabled: feebusterConfig.enabled || gpi.fee_buster_config.enabled,
      fraction: feebusterConfig.fraction || gpi.fee_buster_config.fraction,
      manualinclusive: feebusterConfig.manualinclusive || gpi.fee_buster_config.manualinclusive
    },
    price_increase: {
      enabled: feebusterConfig.priceIncrease || gpi.price_increase.enabled,
      excludedDepts: excludedDepts
    }
  } : gpi;
  var result = restoreCalc(basket, {
    gpiConfig: gpiConfig,
    pointsConfig: pointsConfig
  });
  return basket.metadata ? _objectSpread(_objectSpread({}, result), {}, {
    metadata: basket.metadata
  }) : result;
};
module.exports = unpackBasket;